import type { CrmMessages } from "./englishCrmMessages";

export const portugueseCrmMessages = {
  resources: {
    campaigns: {
      name: "Campanha |||| Campanhas",
      forcedCaseName: "Campanha",
      fields: {
        name: "Nome da campanha",
        tipo: "Tipo",
        revista: "Revista",
        data_inicio: "Data de início",
        data_fim: "Data de fim",
        archived_at: "Arquivada em",
      },
      tipos: {
        edicao: "Edição",
        periodo: "Período",
        evento: "Evento",
      },
      action: {
        create: "Criar campanha",
        edit: "Editar campanha",
        new: "Nova Campanha",
      },
      archived: {
        success: "Campanha arquivada com sucesso",
        error: "Erro ao arquivar campanha",
      },
      empty: {
        title: "Nenhuma campanha encontrada",
        description: "Sua lista de campanhas está vazia.",
      },
    },
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nome da empresa",
        website: "Website",
        linkedin_url: "LinkedIn",
        phone_number: "Telefone",
        created_at: "Criada em",
        nb_contacts: "Número de contatos",
        revenue: "Faturamento",
        sector: "Ramo de atuação",
        size: "Porte",
        tax_identifier: "CNPJ / CPF",
        address: "Endereço",
        city: "Cidade",
        zipcode: "CEP",
        state_abbr: "Estado",
        country: "País",
        description: "Descrição",
        context_links: "Links de contexto",
        sales_id: "Vendedora responsável",
        revistas: "Revistas",
        ramos: "Ramos de atuação",
        observacoes: "Observações",
      },
      empty: {
        description: "Sua lista de empresas está vazia.",
        title: "Nenhuma empresa encontrada",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contato",
        additional_info: "Informações adicionais",
        address: "Endereço",
        context: "Contexto",
      },
      action: {
        create: "Criar Empresa",
        edit: "Editar empresa",
        new: "Nova Empresa",
        show: "Ver empresa",
      },
      added_on: "Adicionada em %{date}",
      followed_by: "Acompanhada por %{name}",
      followed_by_you: "Acompanhada por você",
      no_contacts: "Nenhum contato",
      nb_contacts: "%{smart_count} contato |||| %{smart_count} contatos",
      nb_deals: "%{smart_count} proposta |||| %{smart_count} propostas",
      sizes: {
        one_employee: "1 funcionário",
        two_to_nine_employees: "2-9 funcionários",
        ten_to_forty_nine_employees: "10-49 funcionários",
        fifty_to_two_hundred_forty_nine_employees: "50-249 funcionários",
        two_hundred_fifty_or_more_employees: "250 ou mais funcionários",
      },
      autocomplete: {
        create_error: "Ocorreu um erro ao criar a empresa",
        create_item: "Criar %{item}",
        create_label: "Comece a digitar para criar uma nova empresa",
      },
    },
    contacts: {
      name: "Contato |||| Contatos",
      forcedCaseName: "Contato",
      field_categories: {
        background_info: "Histórico e informações",
        identity: "Identidade",
        misc: "Diversos",
        personal_info: "Informações pessoais",
        position: "Cargo",
      },
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        last_seen: "Último contato",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Endereços de e-mail",
        email: "E-mail",
        phone_jsonb: "Números de telefone",
        phone_number: "Telefone",
        linkedin_url: "LinkedIn",
        background: "Observações",
        has_newsletter: "Recebe newsletter",
        sales_id: "Vendedora responsável",
      },
      action: {
        add: "Adicionar contato",
        add_first: "Adicionar seu primeiro contato",
        create: "Criar contato",
        edit: "Editar contato",
        export_vcard: "Exportar vCard",
        new: "Novo Contato",
        show: "Ver contato",
      },
      background: {
        last_activity_on: "Última atividade em %{date}",
        added_on: "Adicionado em %{date}",
        followed_by: "Acompanhado por %{name}",
        followed_by_you: "Acompanhado por você",
        status_none: "Nenhum",
      },
      position_at: "%{title} na empresa",
      position_at_company: "%{title} na %{company}",
      empty: {
        description: "Sua lista de contatos está vazia.",
        title: "Nenhum contato encontrado",
      },
      import: {
        title: "Importar contatos",
      },
      inputs: {
        genders: {
          male: "Ele/Dele",
          female: "Ela/Dela",
          nonbinary: "Elu/Delu",
        },
        personal_info_types: {
          work: "Trabalho",
          home: "Pessoal",
          other: "Outro",
        },
      },
      list: {
        error_loading: "Erro ao carregar contatos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Voltar para tags",
        create_description:
          "Crie uma nova tag e aplique aos contatos selecionados.",
        description:
          "Escolha uma tag existente ou crie uma nova para os contatos selecionados.",
        empty:
          "Nenhuma tag ainda. Crie uma para etiquetar os contatos selecionados.",
        error: "Falha ao adicionar tag aos contatos",
        removed:
          "Tag removida de %{smart_count} contato |||| Tag removida de %{smart_count} contatos",
        success:
          "Tag adicionada a %{smart_count} contato |||| Tag adicionada a %{smart_count} contatos",
        title: "Adicionar tag aos contatos",
      },
      merge: {
        action: "Mesclar com outro contato",
        confirm: "Mesclar Contatos",
        current_contact: "Contato atual (será excluído)",
        description: "Mescle este contato com outro.",
        error: "Falha ao mesclar contatos",
        merging: "Mesclando...",
        no_additional_data: "Sem dados adicionais para mesclar",
        select_target: "Selecione um contato para mesclar",
        success: "Contatos mesclados com sucesso",
        target_contact: "Contato de destino (será mantido)",
        title: "Mesclar Contato",
        warning_description:
          "Todos os dados serão transferidos para o segundo contato. Esta ação não pode ser desfeita.",
        warning_title: "Aviso: Operação destrutiva",
        what_will_be_merged: "O que será mesclado:",
      },
      filters: {
        before_last_month: "Antes do mês passado",
        before_this_month: "Antes deste mês",
        before_this_week: "Antes desta semana",
        managed_by_me: "Minha carteira",
        search: "Buscar nome, empresa...",
        this_week: "Esta semana",
        today: "Hoje",
        tags: "Tags",
        tasks: "Tarefas",
      },
      hot: {
        empty_change_status:
          'Altere o status de um contato adicionando uma nota a ele e clicando em "mostrar opções".',
        empty_hint: 'Contatos com status "quente" aparecerão aqui.',
        title: "Contatos Quentes",
      },
      validation: {
        company_required: "Empresa é obrigatória",
      },
    },
    deals: {
      name: "Proposta |||| Propostas",
      fields: {
        name: "Nome da proposta",
        description: "Descrição",
        company_id: "Empresa",
        contact_ids: "Contatos",
        category: "Veículo",
        amount: "Valor proposto",
        valor_negociado: "Valor negociado",
        expected_closing_date: "Data prevista de fechamento",
        stage: "Estágio",
      },
      validation: {
        company_required: "Empresa é obrigatória",
      },
      action: {
        back_to_deal: "Voltar para a proposta",
        create: "Criar proposta",
        new: "Nova Proposta",
      },
      field_categories: {
        misc: "Diversos",
      },
      filters: {
        only_mine: "Minhas propostas",
      },
      archived: {
        action: "Arquivar",
        error: "Erro: proposta não arquivada",
        list_title: "Propostas Arquivadas",
        success: "Proposta arquivada",
        title: "Proposta Arquivada",
        view: "Ver propostas arquivadas",
      },
      inputs: {
        linked_to: "Vincular a",
      },
      unarchived: {
        action: "Restaurar para o painel",
        error: "Erro: proposta não restaurada",
        success: "Proposta restaurada",
      },
      updated: "Proposta atualizada",
      empty: {
        before_create: "antes de criar uma proposta.",
        description: "Sua lista de propostas está vazia.",
        title: "Nenhuma proposta encontrada",
      },
      import: {
        title: "Importar propostas",
      },
      invalid_date: "Data inválida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Status",
        date: "Data",
        attachments: "Anexos",
        contact_id: "Contato",
        deal_id: "Proposta",
      },
      action: {
        add: "Adicionar nota",
        add_first: "Adicionar sua primeira nota",
        delete: "Excluir nota",
        edit: "Editar nota",
        update: "Atualizar nota",
        add_this: "Adicionar esta nota",
      },
      sheet: {
        create: "Criar nota",
        create_for: "Criar nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota para %{name}",
      },
      deleted: "Nota excluída",
      empty: "Nenhuma nota ainda",
      author_added: "%{name} adicionou uma nota",
      you_added: "Você adicionou uma nota",
      me: "Eu",
      list: {
        error_loading: "Erro ao carregar notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Acesse a página de um contato e adicione uma nota",
      },
      added: "Nota adicionada",
      inputs: {
        add_note: "Adicionar uma nota",
        options_hint: "(anexar arquivos ou alterar detalhes)",
        show_options: "Mostrar opções",
      },
      actions: {
        attach_document: "Anexar documento",
      },
      validation: {
        note_or_attachment_required: "É necessário uma nota ou um anexo",
      },
    },
    sales: {
      name: "Vendedora |||| Vendedoras",
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        email: "E-mail",
        secondary_email: "E-mail secundário",
        secondary_emails: "E-mails secundários",
        administrator: "Gerente",
        disabled: "Desativada",
      },
      create: {
        error: "Ocorreu um erro ao criar a vendedora.",
        success:
          "Vendedora criada. Ela receberá um e-mail em breve para definir a senha.",
        title: "Criar nova vendedora",
      },
      edit: {
        error: "Ocorreu um erro. Tente novamente.",
        record_not_found: "Registro não encontrado",
        success: "Vendedora atualizada com sucesso",
        title: "Editar %{name}",
      },
      action: {
        new: "Nova vendedora",
      },
    },
    tasks: {
      name: "Tarefa |||| Tarefas",
      forcedCaseName: "Tarefa",
      fields: {
        text: "Descrição",
        due_date: "Data de vencimento",
        type: "Tipo",
        contact_id: "Contato",
        due_short: "vence",
      },
      action: {
        add: "Adicionar tarefa",
        create: "Criar tarefa",
        edit: "Editar tarefa",
      },
      actions: {
        postpone_next_week: "Adiar para a próxima semana",
        postpone_tomorrow: "Adiar para amanhã",
        title: "Ações da tarefa",
      },
      added: "Tarefa adicionada",
      deleted: "Tarefa excluída com sucesso",
      dialog: {
        create: "Criar tarefa",
        create_for: "Criar tarefa para %{name}",
      },
      sheet: {
        edit: "Editar tarefa",
        edit_for: "Editar tarefa para %{name}",
      },
      empty: "Nenhuma tarefa ainda",
      empty_list_hint: "Tarefas adicionadas aos seus contatos aparecerão aqui.",
      filters: {
        later: "Mais tarde",
        overdue: "Atrasadas",
        this_week: "Esta semana",
        today: "Hoje",
        tomorrow: "Amanhã",
        with_pending: "Com tarefas pendentes",
      },
      regarding_contact: "(Ref: %{name})",
      updated: "Tarefa atualizada",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Adicionar tag",
        create: "Criar nova tag",
      },
      dialog: {
        color: "Cor",
        create_title: "Criar nova tag",
        edit_title: "Editar tag",
        name_label: "Nome da tag",
        name_placeholder: "Informe o nome da tag",
      },
      empty: "Nenhuma tag ainda.",
    },
  },
  crm: {
    action: {
      reset_password: "Redefinir senha",
    },
    auth: {
      first_name: "Nome",
      last_name: "Sobrenome",
      confirm_password: "Confirmar senha",
      confirmation_required:
        "Siga o link que enviamos por e-mail para confirmar sua conta.",
      recovery_email_sent:
        "Se você estiver cadastrada, receberá um e-mail de recuperação de senha em breve.",
      sign_in_failed: "Falha ao entrar.",
      sign_in_google_workspace: "Entrar com Google Workspace",
      signup: {
        create_account: "Criar conta",
        create_first_user:
          "Crie a primeira conta de usuária para concluir a configuração.",
        creating: "Criando...",
        initial_user_created: "Usuária inicial criada com sucesso",
      },
      welcome_title: "Boas-vindas ao CRM Cultivar",
    },
    common: {
      account_manager: "Vendedora responsável",
      activity: "Atividade",
      added: "adicionou",
      details: "Detalhes",
      last_activity_with_date: "última atividade em %{date}",
      load_more: "Carregar mais",
      misc: "Diversos",
      past: "Passado",
      read_more: "Ler mais",
      retry: "Tentar novamente",
      show_less: "Mostrar menos",
      copied: "Copiado!",
      copy: "Copiar",
      loading: "Carregando...",
      me: "Eu",
      task_count: "%{smart_count} tarefa |||| %{smart_count} tarefas",
    },
    changelog: {
      title: "Notas de atualização",
    },
    activity: {
      added_company: "%{name} adicionou a empresa",
      you_added_company: "Você adicionou a empresa",
      added_contact: "%{name} adicionou o contato",
      you_added_contact: "Você adicionou o contato",
      added_note: "%{name} adicionou uma nota sobre",
      you_added_note: "Você adicionou uma nota sobre",
      added_note_about_deal: "%{name} adicionou uma nota sobre a proposta",
      you_added_note_about_deal: "Você adicionou uma nota sobre a proposta",
      added_deal: "%{name} adicionou a proposta",
      you_added_deal: "Você adicionou a proposta",
      at_company: "na empresa",
      to: "para",
      load_more: "Carregar mais atividades",
    },
    dashboard: {
      deals_chart: "Previsão de Receita de Propostas",
      deals_pipeline: "Funil de Propostas",
      latest_activity: "Última Atividade",
      latest_activity_error: "Erro ao carregar última atividade",
      latest_notes: "Minhas Últimas Notas",
      latest_notes_added_ago: "adicionada %{timeAgo}",
      stepper: {
        install: "Instalar CRM Cultivar",
        progress: "%{step}/3 concluído",
        whats_next: "Próximos passos",
      },
      my_deals: "Minhas propostas",
      stale_deals: "Propostas paradas",
      stale_empty: "Nenhuma proposta parada",
      stale_for: "parada há 1 dia |||| parada há %{smart_count} dias",
      upcoming_tasks: "Próximas Tarefas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importação concluída. %{importCount} registros importados, com %{errorCount} erros",
      csv_file: "Arquivo CSV",
      error:
        "Falha ao importar o arquivo. Certifique-se de enviar um arquivo CSV válido.",
      in_progress: "Importação em andamento…",
      progress:
        "%{importCount} / %{rowCount} registros importados, com %{errorCount} erros.",
      remaining_time: "Tempo restante estimado:",
      resource: "Recurso",
      sample_download: "Baixar exemplo de CSV",
      sample_hint:
        "Aqui está um exemplo de arquivo CSV que você pode usar como modelo",
      start: "Iniciar importação",
      stop: "Parar importação",
      stopped:
        "Importação interrompida. %{importCount} registros importados, com %{errorCount} erros",
      title: "Importar dados",
    },
    header: {
      import_data: "Importar de JSON",
    },
    search: {
      title: "Buscar",
      placeholder: "Buscar contatos, empresas, propostas, tarefas e notas...",
      hint: "Digite pelo menos %{min} caracteres para buscar",
      empty: "Nenhum resultado encontrado",
      error: "A busca está indisponível no momento. Tente novamente.",
      untitled_result: "(sem título)",
      groups: {
        contacts: "Contatos",
        companies: "Empresas",
        deals: "Propostas",
        tasks: "Tarefas",
        contact_notes: "Notas de contato",
        deal_notes: "Notas de proposta",
      },
    },
    image_editor: {
      change: "Alterar",
      drop_hint: "Arraste um arquivo aqui ou clique para selecionar.",
      editable_content: "Conteúdo editável",
      title: "Enviar e redimensionar imagem",
      update_image: "Atualizar Imagem",
    },
    import: {
      action: {
        download_error_report: "Baixar relatório de erros",
        import: "Importar",
        import_another: "Importar outro arquivo",
      },
      error: {
        unable: "Não foi possível importar este arquivo.",
      },
      idle: {
        description_1:
          "Você pode importar vendedoras, empresas, contatos, notas e tarefas.",
        description_2:
          "Os dados devem estar em um arquivo JSON no seguinte formato:",
      },
      status: {
        all_success: "Todos os registros foram importados com sucesso.",
        complete: "Importação concluída.",
        failed: "Falhou",
        imported: "Importado",
        in_progress:
          "Importação em andamento, por favor não saia desta página.",
        some_failed: "Alguns registros não foram importados.",
        table_caption: "Status da importação",
      },
      title: "Importar de JSON",
    },
    settings: {
      about: "Sobre",
      companies: {
        sectors: "Ramos de atuação",
      },
      dark_mode_logo: "Logo do Modo Escuro",
      deals: {
        categories: "Veículos",
        currency: "Moeda",
        pipeline_help:
          "Selecione quais estágios de proposta devem contar no funil.",
        pipeline_statuses: "Status do Funil",
        stages: "Estágios",
      },
      light_mode_logo: "Logo do Modo Claro",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Restaurar Padrões",
      save_error: "Falha ao salvar configurações",
      saved: "Configurações salvas com sucesso",
      saving: "Salvando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferências",
      title: "Configurações",
      app_title: "Nome do Aplicativo",
      sections: {
        branding: "Marca e Logo",
      },
      validation: {
        duplicate: "%{display_name} duplicado(s): %{items}",
        in_use:
          "Não é possível remover %{display_name} ainda usados por propostas: %{items}",
        validating: "Validando…",
        entities: {
          categories: "veículos",
          stages: "estágios",
        },
      },
    },
    theme: {
      dark: "Escuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegação do CRM",
    },
    prospecting: {
      title: "Prospecção",
      tags: "Portfolio",
      tags_hint: "O contato precisa ter todas as tags selecionadas.",
      select_tags: "Selecione uma ou mais tags para ver os contatos.",
      no_contacts: "Nenhum contato visível tem todas as tags selecionadas.",
      contact: "Contato",
      company: "Empresa",
      job_title: "Cargo",
      select_all: "Selecionar todos",
      clear_selection: "Desmarcar todos",
      campaign: "Campanha",
      campaign_placeholder: "Escolha a campanha",
      no_campaigns: "Nenhuma campanha ativa.",
      summary:
        "será criada 1 proposta |||| serão criadas %{smart_count} propostas",
      create: "Criar propostas",
      created: "1 proposta criada |||| %{smart_count} propostas criadas",
      create_error: "Não foi possível criar as propostas.",
    },
    profile: {
      add_secondary_email: "Adicionar e-mail",
      email_taken: "%{email} já está em uso por outra usuária",
      no_secondary_emails: "Nenhum",
      secondary_email_invalid: "%{email} não é um e-mail válido",
      secondary_email_is_primary: "%{email} já é seu e-mail principal",
      secondary_email_taken: "%{email} já está em uso por outra usuária",
      too_many_secondary_emails:
        "Você não pode adicionar mais de 10 e-mails secundários",
      secondary_emails_help:
        "Outros endereços que você usa para enviar e-mails. Deixe um em branco para remover.",
      inbound: {
        description:
          "Você pode enviar e-mails para o endereço de entrada do servidor. O CRM Cultivar processará os e-mails e adicionará notas aos contatos correspondentes.",
        title: "E-mail de entrada",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Use esta URL para conectar seu assistente de IA aos dados do CRM via Model Context Protocol (MCP).",
      },
      password: {
        change: "Alterar senha",
      },
      password_reset_sent:
        "Um e-mail para redefinição de senha foi enviado para seu endereço",
      record_not_found: "Registro não encontrado",
      title: "Perfil",
      updated: "Seu perfil foi atualizado",
      update_error: "Ocorreu um erro. Tente novamente.",
    },
    validation: {
      invalid_url: "Deve ser uma URL válida",
      invalid_linkedin_url: "A URL deve ser do linkedin.com",
    },
  },
} satisfies CrmMessages;
